export enum VisibilityType
{
    None,
    VisibleDefault,
    NonVisibleDefault,
    VisibleForce,
    NonVisibleForce
}